import { Contact } from 'src/model/Contact';
import { Business } from 'src/model/Business';
import { Software } from 'src/model/Software';
import { retryFetch } from './RetryHelper';
import { debug } from 'src/logger';
import initialMetricsPublisher from "src/metrics";

interface CreateA2ZQuoteRequest {
    intakeId: String
    reportingId?: String
    contact: Contact
    business: Business
    software: Software
}

interface CreateA2ZQuoteResponse {
    quoteUrl: string;
    a2zAssociationId: string;
    status: string;
}

export const createA2ZQuote =
    async (params: CreateA2ZQuoteRequest): Promise<CreateA2ZQuoteResponse> => {
        try {
            return await retryFetch(async () => {
                debug('Making CreateA2ZQuote Request:', params);
                const response = await fetch('/getstarted/api/createA2ZQuote', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                });
                if (!response.ok) {
                    if (response.status === 429) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('CreateA2ZQuoteCall');
                        actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                    }
                    throw new Error('Encountered exception when calling CreateA2ZQuote')
                }

                const data = await response.json();
                debug('Received CreateA2ZQuote Response:', data);

                return {
                    quoteUrl: data.quoteUrl,
                    a2zAssociationId: data.a2zAssociationId,
                    status: data.status
                };
            });
        } catch (error) {
            console.error('Encountered exception calling CreateA2ZQuote');
            return { quoteUrl: '', a2zAssociationId: '', status: ''};
        }
}
